const Storage = window.localStorage;

export default Storage;